import { DeleteItemAsync } from "./DeleteItemAsync"

export const deleteAsync: DeleteItemAsync = async (key) => {
  return localStorage.removeItem(key)
}
